import config from "@/config";

// 不适合放到业务请求模块的url
export default {
  upload: `${config.apiPrefix}/base/upload/upload_image`, // 上传
  imgCode: `${config.apiPrefix}base/verification_code/get_image?`,
};
